import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';
import {
  IContractorAreaRequestDTO,
  ErrorDetails
} from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';

export class CreateContractorAreaCommand extends IRequestCommand<
  ICreateContractorAreaResponse,
  ErrorDetails,
  ICreateContractorAreaCommandRequest
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'contractorsAreas';
  override _needAuthenticate = true;

  public setContractorId(id: number) {
    this.urlSections.push('contractorsAreas');
    this.urlSections.push(`${id}`);
    this.composeUrl();
  }
  public setCommandBody(body: ICreateContractorAreaCommandRequest): void {
    this._commandBody = body;
  }
}

export interface ICreateContractorAreaCommandRequest
  extends IContractorAreaRequestDTO,
    ICommandParameters {}

export interface ICreateContractorAreaResponse extends ICommandResponse {
  id: number;
}
